import React, { forwardRef } from "react";
import "./Message.css";
import { Avatar } from "@material-ui/core";
import { selectUser } from "../../Redux/userSlice";
import { useSelector } from "react-redux";
import * as timeago from "timeago.js";
                  //forwardRef if for animation of message using react flip move see it dcoumentation
const Message = forwardRef(
  (
           //it to collect all information which we will use
    { id, contents: { timestamp, displayName, email, photo, message, uid } },
    ref //for chat animation
  ) => {
    const user = useSelector(selectUser);
    return (
       // user.email==email =>thid is so that if user send message then color will be bule and if other person send this thwn normal color and cahnge color in css 
      <div
        ref={ref}          
        className={`message ${user.email === email && "message__sender"}`}
      >
        <Avatar src={photo} className="message__photo" />
        <p>{message}</p>
        <small>
          {timestamp
            ? timeago.format(new Date(timestamp?.toDate()).toLocaleString())
            : ""}
        </small>
      </div>
    );
  }
);

export default Message;
